import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { ReactComponent as WriteIcon } from 'svg/fi_write.svg'
import {
  Control,
  FieldArrayWithId,
  FieldErrors,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { FormValues } from 'utils/type'
import { Me, Usage } from 'service/user'

import { LinkDetailType } from 'service/list'
import classNames from 'classnames'
import { isMobile } from 'react-device-detect'

import { ReactComponent as ImageIcon } from 'svg/fi_image.svg'

import { ReactComponent as YoutubeIcon } from 'svg/fi_youtube.svg'
import { ReactComponent as EditIcon } from 'svg/fi_edit.svg'
import { ReactComponent as StarIcon } from 'svg/star_white.svg'
import { ProductScript } from './ProductScript'
import { ReactComponent as UlClipBoardIcon } from 'svg/u_clipboard.svg'
import { ScriptTooltip } from '../tooltip/ScriptTooltip'
import { UpdateTag } from 'components/tag/UpdateTag'
interface ProductItemEmptyProps {
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
  control: Control<FormValues, any>
  fields: FieldArrayWithId<FormValues, 'products', 'id'>[]
  errors: FieldErrors<FormValues>
  setErrorText: Dispatch<React.SetStateAction<React.ReactNode>>
  userInfo: Me
  usage: Usage | undefined
  error: {
    products: {
      link: boolean
      product: boolean
    }[]
    mainTitle: boolean
    thumbnail: boolean
  }
  selectedLinks: LinkDetailType[]
  setError: any
  isAiName: boolean

  isOpenLinkMethod: boolean
  isOpenExtensionMethod: boolean
  setOpenLinkMethod: Dispatch<SetStateAction<boolean>>
  setOpenExtensionMethod: Dispatch<SetStateAction<boolean>>
}

const ProductItemEmpty = ({
  watch,
  setValue,
  control,
  fields,
  errors,
  error,
  setErrorText,
  userInfo,
  usage,
  selectedLinks,
  setError,
  isAiName,
  isOpenLinkMethod,
  isOpenExtensionMethod,
  setOpenLinkMethod,
  setOpenExtensionMethod,
}: PropsWithChildren<ProductItemEmptyProps>) => {
  const [isOpenTooltip, setOpenTooltip] = useState<boolean>(false)
  return (
    <div
      className={classNames(
        'flex w-[375px] flex-col items-center gap-1 md:w-full',
        { 'px-4': isMobile },
      )}
    >
      <p className="w-full rounded-[6px] bg-[#2E343D] px-2 text-[18px] font-bold text-white">
        상품 1
      </p>
      {/* 상품명 입력 */}
      <div className="mt-6 flex w-full flex-col gap-2">
        <p className="flex w-full items-center gap-2 font-bold">
          <EditIcon />
          상품명 편집
        </p>
        <div className="product_name cursor-pointer">
          <p
            className={classNames(
              'inline-flex items-center gap-2 rounded-[4px] px-2 py-1',
              {
                'bg-[#BBEBEC]': true,
              },
            )}
          >
            {' '}
            <span className="flex h-[22px] w-[65px] items-center justify-center rounded-[4px] bg-[#2E343D] text-[12px] font-bold text-white">
              <StarIcon className="text-white" /> AI 생성
            </span>
            {'--'}
          </p>
        </div>
        <div className="cursor-pointer">
          <p
            className={classNames(
              'inline-flex items-center gap-2 rounded-[4px] px-2 py-1',
              {
                'bg-[#EEF1F7]': true,
              },
            )}
          >
            <span className="shrink-0 rounded-[4px] bg-[#8F929B] px-1 py-[2px] text-[12px] font-bold text-white">
              원본
            </span>
            {'--'}
          </p>
        </div>
      </div>
      <div className="relative w-full">
        <textarea
          value={`패스트컷 확장프로그램에서 수집한 쿠팡이나 알리익스프레스 상품을 먼저 선택해${
            isMobile ? '' : '\n'
          }주셔야 영상으로 만들 상품명을 불러올 수 있어요!`}
          className="mt-2 h-[100px] w-full rounded-[10px] border-[1px] border-[#D9DEE8] bg-white px-4 py-4 text-error md:h-[80px]"
          disabled
        />
        {/* <button
          className={classNames(
            'text-[14px] font-bold text-white bg-main rounded-full h-[48px]  flex items-center justify-center gap-2 w-[156px] absolute md:top-[28%] -top-14 right-3',
            {}
          )}
          type="button"
          onClick={() => {
            if (isOpenLinkMethod && !isOpenExtensionMethod) {
              setOpenLinkMethod(false)
            }
            setOpenExtensionMethod((prev) => !prev)
          }}
        >
          <UlClipBoardIcon />
          상품 선택하기
        </button> */}
      </div>
      {/* 스크립트 생성 */}
      <div className="mt-6 flex w-full flex-col">
        <div className="relative flex w-full justify-between">
          <p className="flex items-center gap-2">
            <WriteIcon />
            <span className="font-bold">AI 대본 생성 & 편집</span>
            <UpdateTag />
          </p>
        </div>

        <div className="mt-2 flex flex-col rounded-[10px] border-[1px]">
          <div className="w-full rounded-t-[10px] bg-[#F6F8FB] px-3 py-2">
            <div className="flex flex-col justify-between gap-2 md:flex-row md:items-center">
              <div className="flex w-full items-center justify-between rounded-[10px] bg-white px-4 py-5 font-bold md:h-[61px]">
                <div className="flex w-full flex-col gap-4 md:flex-row md:items-center md:gap-5">
                  <p className="flex flex-shrink-0 items-center gap-2 text-[14px]">
                    <span className="flex-shrink-0 rounded-[4px] bg-[#D9DEE8] px-1 py-[2px] text-[#8F929B]">
                      컨셉
                    </span>
                    <span className="text-[#8F929B]">{'바이럴형'}</span>
                  </p>
                  <p className="flex items-center gap-2 text-[14px]">
                    <span className="flex-shrink-0 rounded-[4px] bg-[#D9DEE8] px-1 py-[2px] text-[#8F929B]">
                      말투
                    </span>
                    <span className="text-[#8F929B]">
                      {'와 이런게 있다고?'}
                    </span>
                  </p>{' '}
                </div>
                <button
                  className="shrink-0 rounded-[4px] bg-[#2E343D] px-2 py-[6px] text-[14px] text-[white] disabled:bg-[#D9DEE8]"
                  type="button"
                  disabled
                >
                  선택 {'>'}
                </button>
              </div>
              <div className="flex shrink-0 justify-center">
                <button
                  type="button"
                  className="shrink-1 flex items-center gap-2 rounded-full bg-[#2E343D] px-6 py-3 disabled:bg-[#D9DEE8]"
                  disabled
                >
                  <StarIcon />
                  <span className="font-bold text-white">AI 대본 생성하기</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 상품 영상 선택 */}
      <div className="mt-6 flex w-full flex-col">
        <p className="flex w-full items-center gap-2 font-bold">
          <YoutubeIcon />
          상품 영상 선택 0/0
        </p>
        <p className="w-full text-[14px] text-[#8F929B]">
          사용하고 싶은 영상을 선택해주세요. (최우선으로 사용되며, 영상 길이가
          충분할 경우 이미지는 사용되지 않습니다.)
        </p>
      </div>
      <div className={classNames('mt-6 flex w-full flex-col', {})}>
        <p className="flex w-full items-center gap-2 font-bold">
          <ImageIcon />
          상품 대표 이미지 선택 0/0
        </p>
        <p className="w-full text-[14px] text-[#8F929B]">
          사용하고 싶은 이미지를 선택해주세요. (영상 길이에 따라 선택한 이미지가
          모두 사용되지 않을 수 있습니다)
        </p>
      </div>
      <div className={classNames('relative mt-6 flex w-full flex-col', {})}>
        <p className="flex w-full items-center gap-2 font-bold">
          <ImageIcon />
          상품 상세페이지 이미지 선택 0 /0
        </p>
        <p className="w-full text-[14px] text-[#8F929B]">
          사용하고 싶은 이미지를 선택해주세요. (영상 길이에 따라 선택한 이미지가
          모두 사용되지 않을 수 있습니다)
        </p>
      </div>

      {/* 상품 이미지 선택 */}
      {/* <ProductImageSelector
        selectedLink={selectedLink}
        index={index}
        setValue={setValue}
        watch={watch}
      /> */}

      {/* 상품 상세 이미지 */}
      {/* <ProductDetailImageSelector
        selectedLink={selectedLink}
        index={index}
        setValue={setValue}
        watch={watch}
      /> */}

      {/* 이미지 업로드 */}
      {/* <FileUploader watch={watch} i={index} setValue={setValue} /> */}
    </div>
  )
}

export default ProductItemEmpty
